import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch service overrides keyed by slug.
 * Returns { slug: { name_en?, name_ar?, short_en?, short_ar?, features_en?, features_ar? } }
 */
export function useServiceOverrides() {
  const [map, setMap] = useState({});
  useEffect(() => {
    let cancel = false;
    axios.get(`${API}/service-overrides`).then((r) => {
      if (!cancel) setMap(r.data || {});
    }).catch(() => {});
    return () => { cancel = true; };
  }, []);
  return map;
}

/** Merge a single static service with its override (override fields win when present). */
export function mergeService(service, override) {
  if (!override) return service;
  return {
    ...service,
    ...(override.name_en ? { name_en: override.name_en } : {}),
    ...(override.name_ar ? { name_ar: override.name_ar } : {}),
    ...(override.short_en ? { short_en: override.short_en } : {}),
    ...(override.short_ar ? { short_ar: override.short_ar } : {}),
    ...(override.features_en ? { features_en: override.features_en } : {}),
    ...(override.features_ar ? { features_ar: override.features_ar } : {}),
  };
}

export function useIndustryOverrides() {
  const [map, setMap] = useState({});
  useEffect(() => {
    let cancel = false;
    axios.get(`${API}/industry-overrides`).then((r) => {
      if (!cancel) setMap(r.data || {});
    }).catch(() => {});
    return () => { cancel = true; };
  }, []);
  return map;
}

/** Fetch published case studies; returns [] while loading or on error (caller may fallback). */
export function useCaseStudies() {
  const [items, setItems] = useState(null); // null = loading, [] = loaded
  useEffect(() => {
    let cancel = false;
    axios.get(`${API}/case-studies`).then((r) => {
      if (!cancel) setItems(Array.isArray(r.data) ? r.data : []);
    }).catch(() => { if (!cancel) setItems([]); });
    return () => { cancel = true; };
  }, []);
  return items;
}
